<template>
	<div class="complaint_wrapper">
        <el-dialog
        :title="$t('other.a571')"
        :visible.sync="dialogVisible"
        width="30%"
       >
        <div v-show="agree">{{$t('other.a576')}}:{{target.fee}}
           
        </div>

		<div v-show="!agree">{{$t('other.a577')}}:
            <el-input-number size="mini" v-model="target.fee" :min="0" ></el-input-number>
        </div>
        <div style="margin:20px 0" v-show="agree">
            <el-input type="textarea" v-model="target.storeMsg" :placeholder="$t('other.a572')"></el-input>
        </div>

        <div style="margin:20px 0" v-show="!agree">
            <el-input type="textarea" v-model="target.storeMsg" :placeholder="$t('other.a573')"></el-input>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
            <el-button type="primary" @click="confirm()">{{$t('other.a279')}}</el-button>
        </span>
        </el-dialog>

		<el-dialog
        :title="$t('other.a578')"
        :visible.sync="dialogVisible03"
        width="60%"
       >
        <div >
           <span class="pic_box" v-for="(img,index) in infoData.images" :key="index">
			   <img v-image-preview style="width:100%" :src="img">
		   </span>
        </div>
        <div style="margin:20px 0" v-show="infoData.sellerMsg">
			{{$t('other.a499')}}：
            <el-input type="textarea" v-model="infoData.sellerMsg" :placeholder="$t('other.a573')"></el-input>
        </div>

		 <div style="margin:20px 0" v-show="infoData.storeMsg">
			 {{$t('other.a579')}}：
            <el-input type="textarea" v-model="infoData.storeMsg" :placeholder="$t('other.a573')"></el-input>
        </div>

		 <div style="margin:20px 0" v-show="infoData.systemMsg">
			 {{$t('other.a580')}}：
            <el-input type="textarea" v-model="infoData.systemMsg" :placeholder="$t('other.a573')"></el-input>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible03 = false">{{$t('other.a5')}}</el-button>
            <!-- <el-button type="primary" @click="confirm()">{{$t('other.a279')}}</el-button> -->
        </span>
        </el-dialog>
    <div class="check_header">
        {{$t('other.a581')}}
    </div>

	<div style="margin-bottom:20px">
		<div>{{$t('other.a582')}}：
			<el-input style="width:250px;margin-right:5px" size="medium" v-model="orderIdSearch" :placeholder="$t('other.a574')" clearable ></el-input>
			<el-button size="medium" type="primary" @click="searchOrer()">{{$t('other.a245')}}</el-button>
		</div>
	</div>
	<div class="second_header">
		<el-tabs v-model="activeName2" @change="getTNVBF()" type="card" >
			<el-tab-pane :label="$t('other.a575')" name="second"></el-tab-pane>
			<el-tab-pane :label="$t('other.a119')" name="four"></el-tab-pane>
		</el-tabs>
	</div>
    <div class="kcbf">
		<div v-for="(item,index) in orderList" :key="index">
			<!-- 订单信息栏 -->
			<div class="item_desc">
				<span class="item_childre">{{$t('other.a87')}}{{item.orderId}}</span>
				<span class="item_childre">{{$t('other.a583')}}：{{item.order.orderStatus}}</span>
				<span class="item_childre">{{$t('other.a584')}}：{{item.order.escrowAmount}}</span>
                <span class="item_childre">{{$t('other.a585')}}：{{item.fee}}</span>
				
			</div>
			<!-- 商品信息栏 -->
			<div class="item_wrapper" v-for="(children,indexTwo) in item.order.items" :key="indexTwo">
				<div class="item_left">
					<div class="pic_box">
						<img style="width:100%" :src="children.image" />
					</div>
					<div class="left_item_box">
						<div class="itemName">{{children.itemName}}</div>
						<div class="itemName">sku：{{children.itemSku}}</div>
						<div class="itemName">{{$t('other.a586')}}：{{children.variationSku}}</div>
						<div class="itemName">{{$t('other.a381')}}：{{children.variationQuantityPurchased}}</div>
					</div>

					<div class="left_item_box">
						<div class="itemName">{{$t('other.a588')}}：{{getTime(item.order.createTime)}}</div>
						<div class="itemName">{{$t('other.a589')}}：{{getTime(item.order.payTime)}}</div>
						<div class="itemName">{{$t('other.a590')}}：{{getTime(item.order.printTime)}}</div>
						<div class="itemName">{{$t('other.a591')}}：{{getTime(item.order.packagedTime)}}</div>
						<div class="itemName">{{$t('other.a317')}}{{showStoreName(item.order.storeId)}}</div>
						
					</div>

					<div class="left_item_box">
						<div class="itemName">{{$t('other.a592')}}：{{item.order.shopName}}</div>
						<div class="itemName">{{$t('other.a593')}}：{{item.order.logistics}}</div>
						<div class="itemName">{{$t('other.a594')}}：{{item.order.trackingNo}}</div>
						<div class="itemName">{{$t('other.a595')}}：{{item.order.platform}}</div>
                        <div class="itemName jvmbfk" v-show="item.sellerMsg">{{$t('other.a499')}}：{{item.sellerMsg}}</div>
                        <div class="itemName jvmbfk" v-show="item.storeMsg">{{$t('other.a579')}}：{{item.storeMsg}}</div>
						<div class="itemName jvmbfk" v-show="item.systemMsg">{{$t('other.a580')}}：{{item.systemMsg}}</div>
					</div>

				</div>
				<div>
					<div class="mediut_btn"><el-button style="min-width:150px;margin:2px 0" size="medium" v-show="activeName2 == 'four' && item.complete" type="danger" >{{$t('other.a596')}}{{item.fee}}{{$t('other.a54')}}</el-button></div>
					<div class="mediut_btn"><el-button style="min-width:150px;margin:2px 0" size="medium" v-show="activeName2 == 'second' && !item.intervene" type="primary" @click="applyOrder(0,item)">{{$t('other.a597')}}</el-button></div>
					<div class="mediut_btn"><el-button style="min-width:150px;margin:2px 0" size="medium" v-show="activeName2 == 'second' && !item.intervene" type="danger" @click="applyOrder(1,item)">{{$t('other.a598')}}</el-button></div>
					<div class="mediut_btn"><el-button style="min-width:150px;margin:2px 0" size="medium" v-show="activeName2 == 'second' && item.intervene" type="danger" >{{$t('other.a599')}}</el-button></div>
					<div class="mediut_btn"><el-button style="min-width:150px;margin:2px 0" size="medium"  type="primary" @click="viewMore(item)">{{$t('other.a600')}}</el-button></div>
				</div>
			</div>
		</div>
	</div>

	<!-- 分页器 -->
	<div class="Pager">
		<el-pagination
		@size-change="handleSizeChange"
		@current-change="handleCurrentChange"
		:current-page="currentPage"
		:page-sizes="[15, 50, 100, 200]"
		:page-size="dataParams.offset"
		layout=" total,sizes, prev, pager, next, jumper"
		:total="orderListCount">
		</el-pagination>
		
	</div>
           
            
          
    
         
          
    
	</div>
</template>

<script>
import orderApi from '../../../api/moudles/order'
import newOrders from '@/api/moudles/newOrders'  
import { mapState, mapMutations } from 'vuex'
import api from '../../../api/api'
import utils from '../../../utils/utils'

	export default {
		data() {
			return {
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')) ,
				userShopslazada:JSON.parse(localStorage.getItem('lazadashopId')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				lazadashopId: JSON.parse(localStorage.getItem('lazadashopId')),
                NumType:4,
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
                shopOptions:[],
                productUrl:'',
                activeName2:'second',
				dataParams:{},
				allStoreIds:[],
				allShopIds:JSON.parse(localStorage.getItem('userInfo')).shopIds,
				orderList:[],
				orderListCount:0,
				currentPage:1,
                dialogVisible:false,
                target:{fee:0},
                agree:null,
				infoData:{
					images:[],
					sellerMsg:'',
				},
				dialogVisible03:false,
				orderIdSearch:null
			
                
				
			}
		},
	
		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
			}),

		},
		watch:{
			activeName2(){
				if(this.activeName2 == 'second'){
					this.dataParams.type=0
					this.dataParams.complete=false
					this.dataParams.orderId=null
					this.dataParams.sellerId=null
					this.getSellerOrder()
				}

				if(this.activeName2 == 'first'){
					this.getSellerProsecutionOrder()
				}

                if(this.activeName2 == 'four'){
                    this.dataParams.type=0
					this.dataParams.complete=true
					this.dataParams.orderId=null
					this.dataParams.sellerId=null
					this.getSellerOrder()
                }
				
			},
			orderIdSearch(){
				if(!this.orderIdSearch){
					this.dataParams.orderId=null
					this.dataParams.page=0
					this.getSellerOrder()

					
				}
			}
		},
        filters:{
            
        },
		created(){
			this.init()
			this.getSellerOrder()
		},
		methods: {

            ...mapMutations("common", [
                "SET_REGISTOR_FALSE",
                'SWITCH_LANG',
            ]),

			searchOrer(){
				if(!this.orderIdSearch){
					return
				}
				this.dataParams.orderId=this.orderIdSearch
				this.dataParams.page=0
				this.getSellerProsecutionOrder()
			},

			viewMore(item){
				console.log(item)
				if(item.images){
					this.infoData.images=item.images.split(',').filter(p => {
						if(p){
							return p
						}
					})

				}else{
					this.infoData.images=[]
				}

				console.log(this.infoData.images)

				this.infoData.sellerMsg=item.sellerMsg
				this.infoData.storeMsg=item.storeMsg
				this.infoData.systemMsg=item.systemMsg
				this.dialogVisible03=true
			},

            confirm(){
                this.target.userId=this.userId
                this.target.complete=this.agree
                if(this.agree){//同意
				console.log(this.target)
                  this.hvjkbf(this.target)
                }else{//拒绝
                   if(!this.target.storeMsg){
                       this.$message.warning(this.$t('other.a601'))
                       return
                   }

                   console.log(this.target)
                    this.hvjkbf(this.target)
                    
                }
                this.dialogVisible=false
                
            },

            hvjkbf(list){
				
                newOrders
                .storeDispose(list)
                .then(res => {
                if(res.code === 200 ){
                console.log('desc',res.data)
                this.$message.success(this.$t('other.a232'))
				this.getSellerOrder()
				this.dialogVisible=false
                }else{
                this.$message.warning(res.msg)
                }
                })
            },

	

			applyOrder(index,item){
               this.agree=index == 0 ? true : false
               this.target=JSON.parse(JSON.stringify(item))
               this.dialogVisible=true
			},

			//获取卖家申诉的订单
			getSellerOrder(){
				this.orderList=[]
				newOrders
				.getSellerComplainOrder(this.dataParams)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				this.orderList=res.data.complains
				this.orderListCount=res.data.count
				console.log('order',this.orderList)
				}else{
				this.$message.warning(res.msg)
				}
				})
			},

			//获取卖家可追诉订单
			getSellerProsecutionOrder(){
				
				orderApi
				.getDistrustOrders(this.dataParams)
				.then(res => {
				if(res.code === 200 ){
				console.log('卖家可追诉订单',res.data)
				this.orderList=res.data.orders
				this.orderListCount=res.data.count
				}else{
				this.message.warning(res.msg)
				}
				})
			},

			// getSellerOrder(){
			// 	newOrders
			// 	.getSellerComplainOrder(this.dataParams)
			// 	.then(res => {
			// 	if(res.code === 200 ){
			// 	console.log('desc',res.data)
			// 	}else{
			// 	this.message.warning(res.msg)
			// 	}
			// 	})
			// },

			init(){
				this.allStoreIds=utils.getAllstorIdsByisUsedForTrue()
				this.dataParams.end=null
				this.dataParams.start=null
				this.dataParams.offset=50
				this.dataParams.orderType=10
				this.dataParams.page=0
				this.dataParams.platform=null
				this.dataParams.shopIds=this.allShopIds
				this.dataParams.sortType=0
				this.dataParams.storeIds=this.allStoreIds
				this.dataParams.userId=this.userId
				
				console.log(this.dataParams)

			},
			
			getTime(time){
				return utils.renderTime(time)
			},
			showStoreName(id){
				return utils.showStoreName(id)
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.dataParams.offset=parseInt(`${val}`)
				this.handleCurrentChange()
			},
			//显示当前第几页
			handleCurrentChange(val) {
				this.currentPage=parseInt(`${val}`)
				this.dataParams.page=parseInt(`${val}`) ? (parseInt(`${val}`) -1) * this.dataParams.offset : 0
				this.getSellerProsecutionOrder()	
				
			},

          


            



   
		
	


		}
	}
</script>

<style lang="scss" scoped>
.complaint_wrapper{

    // flex:1;
    // margin: 50px 0 0 223px;
    // height: calc(100vh - 50px);
	box-sizing: border-box;
	padding: 0 15px;

    .check_header{
        font-size: 18px;
        margin:10px 0 20px 0
        
    }

	.kcbf{
		margin-bottom: 130px;
	}

	.pic_box{
		display: inline-block;
		width: 80px;
		height: 80px;
		overflow: hidden;
	}


	.item_desc{
		box-sizing: border-box;
		padding: 5px 10px;
		border: 1px solid #eee;
		font-size: 18px;


		.item_childre{
				margin-right: 20px;
			}
	}


	.item_wrapper{
		display: flex;
		box-sizing: border-box;
		padding: 5px 10px;
		justify-content: space-between;
		border-top: 1px solid #eee;

		.mediut_btn{
			margin:5px 0 style="min-width:130px;margin:2px 0"
		}
		
		.item_left{
			display: flex;
			

			

			.left_item_box{
				box-sizing: border-box;
				padding: 10px;
			}

			.itemName{
				width: 250px;
				display: -webkit-box;
				overflow: hidden;
				text-overflow: ellipsis;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;


			}

			.jvmbfk{
				color: red;
			}
		}
		
		.pic_box{
			width: 100px;
			height: 100px;
			overflow: hidden;
			cursor: pointer;
		}
	}




    .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

}

	
	

</style>
